import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Form } from 'semantic-ui-react';

import Section from '../../../components/Section';
import { Admin } from '../../../components/sections';

class AdminSettingsSection extends Component {
	constructor(props) {
		super(props);
		this.state = { showAddModal: false, showEditModal: false, item: null, error: null, showAddUser: false, newUserEmail: '', showAddUserSuccess: false };

		this.onAddUpdateSystemInfoMessage = this.onAddUpdateSystemInfoMessage.bind(this);
		this.onAddClicked = this.onAddClicked.bind(this);
		this.onEdit = this.onEdit.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onCloseModal = this.onCloseModal.bind(this);
		this.handleError = this.handleError.bind(this);
		this.onShowAddUser = this.onShowAddUser.bind(this);
		this.onAddUserChange = this.onAddUserChange.bind(this);
		this.onCreateUser = this.onCreateUser.bind(this);
		this.onCreateUserClose = this.onCreateUserClose.bind(this);

		const { actions } = props;
		actions.fetchAdminState();
	}
	onAddClicked(e) {
		this.setState({ showAddModal: true });
	}
	onEdit(e, { data }) {
		this.setState({ showEditModal: true, item: data });
	}
	async onDelete(e, { data }) {
		const { actions } = this.props;
		data.isActive = false;
		await actions.updateSystemInfoMessage(data);
		actions.fetchAdminState();
	}
	async onAddUpdateSystemInfoMessage(infoMessage) {
		const { actions } = this.props;
		try {
			await actions.updateSystemInfoMessage(infoMessage);
			this.setState({ showAddModal: false, showEditModal: false, error: null });
			await actions.fetchAdminState();
		} catch (e) {
			this.handleError(e.error);
		}
	}
	onCloseModal(e) {
		this.setState({ showAddModal: false, showEditModal: false, item: null });
	}
	handleError(error) {
		this.setState({ error });
	}
	onAddUserChange(e, { value }) {
		this.setState({ newUserEmail: value });
	}

	async onCreateUser(e) {
		e.preventDefault();
		const { actions } = this.props;
		const { newUserEmail } = this.state;
		await actions.adminCreateUser(newUserEmail);
		this.setState({ showAddUserSuccess: true });
	}
	onCreateUserClose(e) {
		this.setState({ showAddUser: false, newUserEmail: '', showAddUserSuccess: false });
	}
	onShowAddUser() {
		this.setState({ showAddUser: true });
	}
	render() {
		const { admin } = this.props;
		const { showAddModal, showEditModal, item, error, showAddUser, newUserEmail, showAddUserSuccess } = this.state;
		return (
			<Section name='admin' title='Admin Settings' color='red' mobileShow={this.props.mobileShow}>
				<Modal open={showAddUser} size='tiny'>
					<Modal.Header>New Admin User</Modal.Header>
					<Modal.Content>
						{showAddUserSuccess ? (
							<Header as='h1' content='Email Sent' textAlign='center' />
						) : (
							<Form>
								<Form.Input type='email' name='username' placeholder='Email Address' onChange={this.onAddUserChange} value={newUserEmail} />
							</Form>
						)}
					</Modal.Content>
					<Modal.Actions>
						{showAddUserSuccess ? (
							<Button primary onClick={this.onCreateUserClose}>
								Close
							</Button>
						) : (
							<Button primary onClick={this.onCreateUser}>
								Create
							</Button>
						)}{' '}
					</Modal.Actions>
				</Modal>
				<Admin.SystemInfoMessages items={admin.systemInfoMessages} onAdd={this.onAddClicked} onEdit={this.onEdit} onDelete={this.onDelete} onAddUser={this.onShowAddUser} />
				<Admin.ModalAddSystemInfoMessage open={showAddModal} onAdd={this.onAddUpdateSystemInfoMessage} onClose={this.onCloseModal} error={error} />
				<Admin.ModalEditSystemInfoMessage open={showEditModal} item={item} onEdit={this.onAddUpdateSystemInfoMessage} onClose={this.onCloseModal} />
			</Section>
		);
	}
}

AdminSettingsSection.propTypes = {
	actions: PropTypes.object.isRequired,
	admin: PropTypes.object.isRequired
};

export default AdminSettingsSection;
